import React, { useEffect, useState } from "react";
import { Route } from "react-router";
import Layout from "./components/layout/Layout";
import Login from "./pages/login/Login";
import CambiarComercio from "./components/home/CambiarComercio";
import ReembolsoExpress from "./pages/ReembolsoExpress/ReembolsoExpress";
import ReembolsoComercioRaizen from "./pages/ReembolsoComercioRaizen/ReembolsoComercioRaizen";
import Home from "./pages/Home/Home";
import TransaccionesAgrupadas from "./pages/Consulta/TransaccionesAgrupadas";
import Presentaciones from "./pages/presentaciones/Presentaciones";
import CargarPresentacion from "./pages/cargarPresentacion/CargarPresentacion";
import CambiarContrasena from "./pages/cambiarContraseña/pages/cambiarContrasena";
import FacturasPendientes from "./pages/FacturasPendientes/FacturasPendientes";
import CambiarDatosContacto from "./pages/Contacto/CambiarDatosContacto"
import Instructivos from "./pages/instructivos/Instructivos";
import { getVerify } from "./pages/login/services/login.service";
import ResetPassword from "./pages/cambiarContraseña/pages/resetPassword";
import { PCOM_ROUTES, PrivateRoutes, PublicRoutes, locationIncludes } from './pages/shared/models/routes';
import { STORAGE_LOCAL } from "./pages/shared/models/storages";
import ProtectedRoute from "./pages/shared/components/ProtectedRoute/ProtectedRoute";

// Importacin de Estilos.
import "./css/style.css";
import "./components/layout/normalize.css";
import "primereact/resources/primereact.min.css";
import "./components/layout/themes/nova-light-eden/theme.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";
import "./components/layout/layout.scss";
// Importacin de Imagenes.
import "./images/logo-edenred.png";
import "./images/Edenred_Digital-use.png";
import RecaptchaLoader from "./components/recaptcha/ReCaptchaLoader";
  
interface IState {
  login: boolean;
  loged: boolean;
}

const App = () => {
  const [state, setState] = useState<IState>({
    loged: false,
    login: false,
  });

  const setLogginState: (st_lg: {loged: boolean, login: boolean}) => void = ({loged, login}) => {
    setState({
      ...state,
      loged,
      login
    });
  };
  const unauthRoute: () => boolean = () => {
    if (locationIncludes(PCOM_ROUTES.CARGAR_PRESENTACION)) 
    {
      window.localStorage.setItem(STORAGE_LOCAL.EMAIL_DIRECTED, `${window.location.pathname}${window.location.search}`)
    };

    return locationIncludes(PCOM_ROUTES.RESET_PASSWORD);
  };

  useEffect(() => {
    if (!unauthRoute()) verifySession();
  }, []);

  const verifySession = async () => {
    const {data,status} = await getVerify();
    if(status === 200) setLogginState({loged: data, login: data });
  };

  const handleLogin = (loged: boolean, login: boolean) => setLogginState({loged, login});

  if (state.login && state.loged) {
    return (
      <>
        <RecaptchaLoader />
        <Layout>
          <ProtectedRoute>
            <Route exact path="/" component={Home} />
            <Route exact path={PrivateRoutes.HOME} component={Home} />
            <Route exact path={PrivateRoutes.REEMBOLSO_EXPRESS} component={ReembolsoExpress} />
            <Route exact path={PrivateRoutes.SHELL_FLOTA} component={ReembolsoComercioRaizen} />
            <Route exact path={PrivateRoutes.REEMBOLSO_EXPRESS} component={ReembolsoExpress} />
            <Route exact path={PrivateRoutes.CAMBIAR_COMERCIO} component={CambiarComercio} />
            <Route exact path={PrivateRoutes.PRESENTACIONES} component={Presentaciones} />
            <Route exact path={PrivateRoutes.TRANSACCIONES_AGRUPADAS} component={TransaccionesAgrupadas} />
            <Route exact path={PrivateRoutes.CARGAR_PRESENTACION} component={CargarPresentacion} />
            <Route exact path={PrivateRoutes.FACTURAS_PENDIENTES} component={FacturasPendientes} />
            <Route exact path={PrivateRoutes.CAMBIAR_DATOS_CONTACTO} component={CambiarDatosContacto} />
            <Route exact path={PrivateRoutes.CAMBIAR_PASSWORD} component={CambiarContrasena} />
            <Route exact path={PrivateRoutes.INSTRUCTIVOS} component={Instructivos} />
          </ProtectedRoute>
        </Layout>
      </>
    );
  } else {
    return (
      <>
        <RecaptchaLoader />
        <Route
          exact
          path="/"
          component={() => <Login enviarLogeo={handleLogin} />}
        />
        <Route
          exact
          path={PublicRoutes.RESET_PASSWORD}
          component={ResetPassword}
        />
      </>
    );
  }
};

export default App;
